<template>
    <div class="pa-5">
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">{{ t("ID") }}</th>
                    <th class="text-left">{{ t("Production order number") }}</th>
                    <th class="text-left">{{ t("Line number") }}</th>
                    <th class="text-left">{{ t("Production date") }}</th>
                    <th class="text-left">{{ t("Production start") }}</th>
                    <th class="text-left">{{ t("") }}</th>
                    <th class="text-left">{{ t("Product name") }}</th>
                    <th class="text-left">{{ t("Status") }}</th>
                    <th class="text-left"></th>
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="workOrder in activeWorkOrderGroup.work_orders"
                        :key="workOrder.id"
                        class="cursor-pointer"
                        @click="handleTableRowClick(workOrder.id)"
                >
                    <td>{{ workOrder.id }}</td>
                    <td>{{ workOrder.production_order_number }}</td>
                    <td>{{ formatLineNumber(workOrder.line_number) }}</td>
                    <td>{{ workOrder.production_date ? formatDate(workOrder.production_date) : "-" }}</td>
                    <td>{{ workOrder.production_date ? formatTime(workOrder.production_date) : "-" }}</td>
                    <td
                            class="font-weight-bold"
                            :style="{ color: dayDiffColor(workOrder.production_date_days_diff) }"
                    >
                        {{ formatDayDiff(workOrder.production_date_days_diff) }}
                    </td>
                    <td>{{ workOrder.product_name }}</td>
                    <td class="font-weight-bold" :style="{ color: statusColor(workOrder.status) }">
                        {{ workOrder.status ? formatStatus(workOrder.status) : "-" }}
                    </td>
                    <td>
                        <v-btn
                                icon
                                @click.stop="handleDeleteWorkOrderClick(workOrder.id)"
                                v-if="user && user.role === PermissionsConstants.ROLE_SUPERADMIN"
                        >
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {workOrderMixin} from "@/mixins/work-order-mixin";
import {PermissionsConstants} from "@/permissions";

export default {
    name: "group-work-orders-list-tab",
    mixins: [workOrderMixin],
    props: {
        stayToWorkOrder: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        PermissionsConstants() {
            return PermissionsConstants;
        },
        ...mapState("WorkOrderStore", ["activeWorkOrderGroup"]),
        ...mapState(["user"]),
        formatTime() {
            return dateString => {
                const date = new Date(dateString);
                return date.toLocaleTimeString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit"
                });
            };
        }
    },
    methods: {
        ...mapActions("WorkOrderStore", ["fetchWorkOrderGroupData", "deleteWorkOrder", "fetchWorkOrders", "getWorkOrder"]),
        async handleTableRowClick(workOrderID) {
            if (this.stayToWorkOrder) {
                await this.getWorkOrder(workOrderID);
            }

            this.$router.push({name: "work-order-view", params: {workOrderId: workOrderID}});
        },
        async handleDeleteWorkOrderClick(workOrderID) {
            if (confirm(this.t("Are you sure you want to delete this work order?"))) {
                await this.deleteWorkOrder(workOrderID);
                await this.fetchWorkOrderGroupData(this.activeWorkOrderGroup.id);
                await this.fetchWorkOrders({});
            }
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-GB").replaceAll("/", ".");
        },
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}

.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
